import React, { Component } from 'react';
import globalURL from 'helper/url';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import DarkBoxInput from '@lyearn-team/frontend-components/dist/Input/DarkBoxInput';
import DarkButton from '@lyearn-team/frontend-components/dist/Button/DarkButton';
import { ResetPasswordErrors } from '../shared/consts';
import { qs, findCompanyName } from '../shared/static';
import { LoginContentHeading, LoginNormalText } from '../styles';
import {
  GlobalMessage,
  buttonClass,
  CompanyPageWrapper,
  FixWidthColumn,
  passwordInputClass,
  passwordWrapperClass,
  SetPasswordInput
} from './styles';

class DarkSetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      loading: false,
      errorMessage: '',
      globalError: '',
      successMessage: ''
    };
  }

  onPasswordChange = e => {
    this.clearAllState();
    this.setState({ password: e.target.value });
  };

  onConfirmPasswordChange = e => {
    this.clearAllState();
    this.setState({ confirmPassword: e.target.value });
  };

  onEnter = e => {
    if (e.keyCode === 13) {
      this.setPassword();
    }
  };

  setPassword = event => {
    event.preventDefault();
    if (!this.validateInputs()) return false;
    const { password } = this.state;
    this.setState({ loading: true });
    const url = globalURL.awsEndpoint + '/setPassword';
    const name =
      qs('name') &&
      qs('name')
        .split('+')
        .join(' ');
    const email = qs('uniqueId');
    const globalErrorMessage = (
      <GlobalMessage>
        Sorry! There is some problem in resetting password. Please reach out to us at&nbsp;
        <a href="mailto:support@lyearn.com" style={{ 'text-decoration': 'none' }}>
          support@lyearn.com
        </a>
      </GlobalMessage>
    );
    fetch(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        uniqueId: email,
        name,
        password,
        subDomain: findCompanyName()
      })
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ loading: false });
        if (!data.error) {
          this.setState({
            successMessage: <GlobalMessage>Your password has been set successfully!</GlobalMessage>
          });
        } else {
          this.setState({ globalError: globalErrorMessage });
        }
      })
      .catch(() => {
        this.setState({ globalError: globalErrorMessage });
      });
    return true;
  };

  clearAllState = () => {
    const { errorMessage, globalError, successMessage } = this.state;
    if (errorMessage) {
      this.setState({ errorMessage: '' });
    }
    if (globalError) {
      this.setState({ globalError: '' });
    }
    if (successMessage) {
      this.setState({ successMessage: '' });
    }
  };

  validateInputs = () => {
    const { password, confirmPassword } = this.state;
    if (!password) {
      this.setState({ errorMessage: ResetPasswordErrors.PASSWORD_REQUIRED });
      return false;
    }
    if (!confirmPassword) {
      this.setState({ errorMessage: ResetPasswordErrors.CONFIRM_PASSWORD_REQUIRED });
      return false;
    }
    if (password !== confirmPassword) {
      this.setState({ errorMessage: ResetPasswordErrors.DO_NOT_MATCH });
      return false;
    }
    return true;
  };

  renderActivityIndicator = () => (
    <ActivityIndicator
      svgColor="#fff"
      style={{ marginRight: '6px', fill: '#fff' }}
      width={16}
      height={16}
    />
  );

  render() {
    const {
      password,
      confirmPassword,
      loading,
      errorMessage,
      globalError,
      successMessage
    } = this.state;
    let icon = '';
    if (loading) {
      icon = this.renderActivityIndicator();
    }
    const isButtonDisabled = !(password && confirmPassword) || loading;
    let confirmPasswordError = '';
    if (errorMessage === ResetPasswordErrors.CONFIRM_PASSWORD_REQUIRED) {
      confirmPasswordError = <div>&nbsp;</div>;
    }
    if (errorMessage === ResetPasswordErrors.DO_NOT_MATCH) {
      confirmPasswordError = 'Passwords do not match';
    }

    return (
      <CompanyPageWrapper className="pageWrapper">
        <LoginContentHeading>Set Password</LoginContentHeading>
        <LoginNormalText>Set password for {qs('uniqueId')}</LoginNormalText>
        <form className={FixWidthColumn} onSubmit={this.setPassword}>
          <SetPasswordInput>
            <DarkBoxInput.Password
              placeholder="Enter New Password"
              value={password}
              required={true}
              onChange={this.onNewPasswordChange}
              className={passwordInputClass}
              passwordWrapperClassName={passwordWrapperClass}
            />

            <DarkBoxInput.Password
              placeholder="Confirm New Password"
              value={confirmPassword}
              required={true}
              onChange={this.onConfirmPasswordChange}
              className={passwordInputClass}
              passwordWrapperClassName={passwordWrapperClass}
            />
            {confirmPasswordError}
            {globalError}
            {successMessage}
          </SetPasswordInput>
          <DarkButton className={buttonClass} type="submit" disabled={isButtonDisabled}>
            {icon}
            {loading ? 'CONTINUING' : 'CONTINUE'}
          </DarkButton>
        </form>
      </CompanyPageWrapper>
    );
  }
}

export default DarkSetPassword;
